import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMenuSections } from '../layout/Sidebar';

export default function RedirectToFirstAvailable() {
  const { hasAnyPermission } = useAuth();

  // Get all menu items from the sidebar configuration
  const menuSections = getMenuSections();
  const allMenuItems = menuSections.flatMap(section => section.items);

  // Find the first menu item the user has access to
  const firstAvailable = allMenuItems.find(item => 
    !item.permissions || hasAnyPermission(item.permissions)
  );

  return <Navigate to={firstAvailable?.path || '/unauthorized'} replace />;
}
